export default __webpack_public_path__ + "static/media/trash-compactor.a30fb901.svg";